import {AuditDetailsValue} from "@/pages/pagespeed/report/body/AuditDetailsValue.tsx";

interface AuditDetailsTableProps {
  headings: unknown[];
  items: unknown[];
  subheadings?: unknown[];
}

export const AuditDetailsTable = ({headings, items, subheadings}: AuditDetailsTableProps) => {
  const isSubitems = subheadings === undefined;
  // @ts-expect-error unknown type
  const hdrs = headings.filter((h) => h).map((h) => <th key={h.key}>{h.text}</th>);
  const rows = [];
  for (let i = 0; i < items.length; i++) {
    const cells = [];
    for (let j = 0; j < headings.length; j++) {
      if (headings[j] == null) {
        continue;
      }
      // @ts-expect-error unknown type
      const key = headings[j].key;
      // @ts-expect-error unknown type
      const type = headings[j].type;
      // @ts-expect-error unknown type
      const val = items[i][key];
      cells.push(
        <td key={`${i}_${j}_${key}`}>
          <AuditDetailsValue val={val} valueType={type} />
        </td>
      );
    }
    rows.push(
      <tr key={`row${i}`} className={isSubitems ? "subitem" : ""}>
        {cells}
      </tr>
    );
    // @ts-expect-error unknown type
    if (items[i].subItems) {
      rows.push(
        // @ts-expect-error unknown type
        <AuditDetailsTable key={`audit-details-${i}`} headings={subheadings} items={items[i].subItems.items} />
      );
    }
  }
  if (isSubitems) {
    return rows;
  } else {
    return (
      <div className="table-responsive">
        <table className="table audit-details">
          <thead>
            <tr>{hdrs}</tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
      </div>
    );
  }
};
